var MinimalHitboxTypes;
(function (MinimalHitboxTypes) {
    /**
     * @description Only use when the hitbox is not necessary to be at least 48px high.
     */
    MinimalHitboxTypes["width"] = "width";
    /**
     * @description Only use when the hitbox is not necessary to be at least 48px wide.
     */
    MinimalHitboxTypes["height"] = "height";
    MinimalHitboxTypes["both"] = "both";
    /**
     * @description Only use (in very rare use-cases) when the hitbox is not necessary to be at least 48x48px.
     */
    MinimalHitboxTypes["none"] = "none";
})(MinimalHitboxTypes || (MinimalHitboxTypes = {}));
export default MinimalHitboxTypes;
